import Lottie from 'lottie-web';

class Teaser {
	jsonUrl = 'upload/layout/animationen/pfeil.json';
	constructor($el) {
		this.$el = $el;
		this.$animation = this.$el.find('[data-teaser="animation"]');
		this.init();
	}

	init = () => {
		// create Lottie Animation
		this.animation = Lottie.loadAnimation({
			container: this.$animation[0],
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path: this.jsonUrl,
		});

		// play animation on hover
		this.$el.on('mouseenter', this.handleMouseEnter);
		this.$el.on('mouseleave', this.handleMouseLeave);
	};

	handleMouseEnter = () => {
		this.animation.goToAndPlay(0);
	};

	handleMouseLeave = () => {
		// this.animation.pause();
	};
}

export default Teaser;
